import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { showGlobalLoader } from './globalLoader';
import { isNoLoaderRoute } from './utils/loaderRoutes';

export { showGlobalLoader } from './globalLoader';

if (!isNoLoaderRoute(window.location.pathname)) {
  showGlobalLoader(true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
